/**
 * Get a number in the range [start, end]
 * @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
 */
export const randomInteger = (end = Number.MAX_SAFE_INTEGER, start = 0) => {
  if (end < start) return 0;
  const min = Math.ceil(start);
  const max = Math.floor(end);
  return min + Math.floor(Math.random() * (max - min + 1));
};

/**
 * Returns a random entry in A
 */
export const randomEntry = <T>(A: T[]): T => {
  const index = randomInteger(A.length - 1);
  return A[index];
};

/**
 * Returns B such that B is a random key of A
 */
export const randomKey = <K extends string, T>(A: Record<K, T>): K => {
  const keys = Object.keys(A);
  const index = randomInteger(keys.length - 1);
  return keys[index] as K;
};

export default { randomInteger, randomEntry, randomKey };
